import { isNone } from '@ember/utils';

export function queryDecode(value: string): Record<string, any> | Record<string, any>[] {
  let rawJSON = atob(value);
  let decodedJSON;

  try {
    decodedJSON = decodeURIComponent(rawJSON);
  } catch {
    // JSON isn't encoded on the back end; no need to decode
    decodedJSON = rawJSON;
  }

  return JSON.parse(decodedJSON);
}

export function queryEncode(value: Record<string, any> | Record<string, any>[]): string {
  return btoa(encodeURIComponent(JSON.stringify(value)));
}

export function safeQueryDecode(value: string) {
  try {
    return queryDecode(value) || [];
  } catch (e) {
    return [];
  }
}

export function queryConcat(...args: any[]) {
  let conditions = [...args].filter((arg) => !isNone(arg));
  let concatenatedConditions = conditions.reduce((a, b) => [...a, ...b]);
  return queryEncode(concatenatedConditions);
}
